import { BrowserRouter } from 'react-router-dom';
import { Normalize } from 'styled-normalize';
import AppContextProvider from '@nxsys/context/AppContextProvider';
import AppThemeProvider from '@nxsys/context/AppThemeProvider';
import AppLocaleProvider from '@nxsys/context/AppLocaleProvider';
import AppAuthProvider from '@nxsys/core/AppAuthProvider';
import AuthRoutes from '@nxsys/components/AuthRoutes';
import AppLayout from '@nxsys/core/AppLayout';
import SessionTimeout from '@nxsys/components/SessionTimeout';
import RecordNotFoundRedirect from '@nxsys/components/RecordNotFoundRedirect';
import { GlobalStyles, useScrollbarGlow } from '@nxsys/core/theme/GlobalStyle';
import { useThemeContext } from '@nxsys/context/AppContextProvider/ThemeContextProvider';
import '@nxsys/mockapi';
import './styles/loader.css';
import moment from 'moment';

function App() {
  moment.tz.setDefault('Etc/UTC');
  const { theme } = useThemeContext();
  useScrollbarGlow();

  return (
    <AppContextProvider>
      <AppThemeProvider>
        <AppLocaleProvider>
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <AppAuthProvider>
              <AuthRoutes>
                <GlobalStyles theme={theme as any} />
                <Normalize />
                {/* Sits beside AppLayout rather than inside it so the idle
                    countdown survives route changes (NX-5238). */}
                <SessionTimeout />
                <RecordNotFoundRedirect />
                <AppLayout />
              </AuthRoutes>
            </AppAuthProvider>
          </BrowserRouter>
        </AppLocaleProvider>
      </AppThemeProvider>
    </AppContextProvider>
  );
}

export default App;
